import { fetchWithAuth } from '@/api/auth/fetchWithAuth';
import {
  IForgotPasswordData,
  ILoginData,
  IRecoverPasswordData,
  IRegisterData,
  IUser,
} from '@/api/auth/types';
import { ensureVisitorId } from '@/utils/visitorId/visitorId';

export const API_URL = process.env.NEXT_PUBLIC_API_URL;

export const login = async (body: ILoginData) =>
  fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());

export const register = async (body: IRegisterData) =>
  fetch(`${API_URL}/auth/register`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());

export const verifyEmail = async (token: string) =>
  fetch(`${API_URL}/auth/verify-email?token=${token}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());

export const forgotPassword = async (body: IForgotPasswordData) =>
  fetch(`${API_URL}/auth/forgot-password`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());

export const recoverPassword = async (body: IRecoverPasswordData) =>
  fetch(`${API_URL}/auth/recover-password`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((r) => r.json());

export const getUser = async (): Promise<IUser> => {
  const res = await fetchWithAuth(`${API_URL}/auth/me`);
  if (!res.ok) throw new Error('Failed to fetch user');

  return (await res.json()) as IUser;
};

export const getGuest = async () => {
  const visitorId = await ensureVisitorId();
  const res = await fetch(`${API_URL}/guest/me`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-guest-signature': visitorId ?? '',
    },
  });
  if (!res.ok) throw new Error('Failed to fetch guest');

  return await res.json();
};
